export default __webpack_public_path__ + "static/media/BLUE_BACK.d7aabd90.svg";